import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, mergeProps as _mergeProps, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot } from "vue"

import { ref, computed, onMounted } from 'vue';
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';
import HolidayRemote from "@/components/common/HolidayRemote.vue";
import SugaRemote from "@/components/common/SugaRemote.vue";
import TaxRateRemote from "@/components/common/TaxRateRemote.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'AdminLayout',
  setup(__props) {

const store = useStore();
const router = useRouter();

// HolidayRemote 컴포넌트 ref
const holidayRemoteRef = ref<{ openDialog: () => void } | null>(null);

// SugaRemote 컴포넌트 ref
const sugaRemoteRef = ref<{ openDialog: () => void } | null>(null);

// TaxRateRemote 컴포넌트 ref
const taxRateRemoteRef = ref<{ openDialog: () => void } | null>(null);

// 사이드바 상태
const drawer = ref(false);

// 사용자 정보 (Vuex에서 가져오기)
const userInfo = computed(() => store.getters.currentUser);

// Admin 메뉴 아이템들
const menuItems = ref([
  {
    title: '회원 관리',
    icon: 'mdi-account-group',
    to: '/admin/members'
  },
  {
    title: '공지사항',
    icon: 'mdi-bullhorn',
    to: '/admin/notice'
  },
  {
    title: '기타 관리',
    icon: 'mdi-cog',
    children: [
      {
        title: '공휴일 관리',
        icon: 'mdi-calendar',
        action: 'openHolidayRemote'
      },
      {
        title: '수가 관리',
        icon: 'mdi-cash-multiple',
        action: 'openSugaRemote'
      },
      {
        title: '세금 요율 관리',
        icon: 'mdi-percent',
        action: 'openTaxRateRemote'
      },
      {
        title: '가격 정책',
        icon: 'mdi-tag-heart',
        to: '/admin/pricing'
      },
      {
        title: '설 특집 쇼핑몰',
        icon: 'mdi-gift',
        to: '/admin/shop'
      }
    ]
  }
]);

// 공휴일 관리 다이얼로그 열기
const openHolidayRemote = () => {
  if (holidayRemoteRef.value) {
    holidayRemoteRef.value.openDialog();
  }
};

// 수가 관리 다이얼로그 열기
const openSugaRemote = () => {
  if (sugaRemoteRef.value) {
    sugaRemoteRef.value.openDialog();
  }
};

// 세금 요율 관리 다이얼로그 열기
const openTaxRateRemote = () => {
  if (taxRateRemoteRef.value) {
    taxRateRemoteRef.value.openDialog();
  }
};

// 메뉴 액션 처리
const handleMenuAction = (action: string) => {
  if (action === 'openHolidayRemote') {
    openHolidayRemote();
  } else if (action === 'openSugaRemote') {
    openSugaRemote();
  } else if (action === 'openTaxRateRemote') {
    openTaxRateRemote();
  }
};

// 로그아웃 처리
const handleLogout = async () => {
  try {
    await store.dispatch('performLogout');
    router.push('/pgm/login');
  } catch (error) {
    console.error('로그아웃 오류:', error);
  }
};

onMounted(async () => {
  await store.dispatch('validateAuth');
  
  // Admin이 아닌 경우 일반 페이지로 리다이렉트
  if (!store.getters.isAdmin) {
    router.push('/pgm/wage/WageProcess');
    return;
  }
});

return (_ctx: any,_cache: any) => {
  const _component_v_app_bar_nav_icon = _resolveComponent("v-app-bar-nav-icon")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_toolbar_title = _resolveComponent("v-toolbar-title")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_menu = _resolveComponent("v-menu")!
  const _component_v_app_bar = _resolveComponent("v-app-bar")!
  const _component_v_avatar = _resolveComponent("v-avatar")!
  const _component_v_list_item_subtitle = _resolveComponent("v-list-item-subtitle")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_list_group = _resolveComponent("v-list-group")!
  const _component_v_navigation_drawer = _resolveComponent("v-navigation-drawer")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_v_main = _resolveComponent("v-main")!
  const _component_v_app = _resolveComponent("v-app")!

  return (_openBlock(), _createBlock(_component_v_app, {
    id: "admin-app",
    class: "admin-layout"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_app_bar, {
        color: "#1a237e",
        elevation: "2",
        height: "56",
        class: "admin-app-bar"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_app_bar_nav_icon, {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (drawer.value = !drawer.value)),
            color: "white"
          }),
          _createVNode(_component_v_toolbar_title, { class: "admin-title" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_icon, {
                class: "mr-2",
                color: "amber"
              }, {
                default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                  _createTextVNode("mdi-shield-crown", -1)
                ]))]),
                _: 1
              }),
              _cache[3] || (_cache[3] = _createTextVNode(" CAION Admin ", -1))
            ]),
            _: 1
          }),
          _createVNode(_component_v_spacer),
          _createVNode(_component_v_chip, {
            color: "amber",
            variant: "flat",
            size: "small",
            class: "mr-4"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_icon, {
                start: "",
                size: "small"
              }, {
                default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                  _createTextVNode("mdi-shield-account", -1)
                ]))]),
                _: 1
              }),
              _cache[5] || (_cache[5] = _createTextVNode(" 관리자 ", -1))
            ]),
            _: 1
          }),
          _createVNode(_component_v_menu, { class: "user-menu" }, {
            activator: _withCtx(({ props }) => [
              _createVNode(_component_v_btn, _mergeProps({ icon: "" }, props, {
                class: "mr-2",
                color: "white"
              }), {
                default: _withCtx(() => [
                  _createVNode(_component_v_icon, null, {
                    default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                      _createTextVNode("mdi-account-circle", -1)
                    ]))]),
                    _: 1
                  })
                ]),
                _: 1
              }, 16)
            ]),
            default: _withCtx(() => [
              _createVNode(_component_v_list, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_list_item, { onClick: handleLogout }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_list_item_title, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_icon, {
                            size: "small",
                            class: "mr-1"
                          }, {
                            default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                              _createTextVNode("mdi-logout", -1)
                            ]))]),
                            _: 1
                          }),
                          _cache[8] || (_cache[8] = _createTextVNode(" 로그아웃 ", -1))
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_v_navigation_drawer, {
        modelValue: drawer.value,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((drawer).value = $event)),
        temporary: "",
        class: "admin-drawer"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_list_item, { class: "admin-drawer-header" }, {
            prepend: _withCtx(() => [
              _createVNode(_component_v_avatar, {
                color: "amber",
                size: "40"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_icon, { color: "white" }, {
                    default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
                      _createTextVNode("mdi-shield-crown", -1)
                    ]))]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            default: _withCtx(() => [
              _createVNode(_component_v_list_item_title, { class: "admin-drawer-title" }, {
                default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
                  _createTextVNode("관리자 메뉴", -1)
                ]))]),
                _: 1
              }),
              _createVNode(_component_v_list_item_subtitle, null, {
                default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
                  _createTextVNode("Administrator Panel", -1)
                ]))]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_divider),
          _createVNode(_component_v_list, { nav: "" }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(menuItems.value, (item) => {
                return (_openBlock(), _createElementBlock(_Fragment, {
                  key: item.title
                }, [
                  (!item.children)
                    ? (_openBlock(), _createBlock(_component_v_list_item, {
                        key: 0,
                        to: item.to,
                        "prepend-icon": item.icon,
                        title: item.title,
                        class: "admin-menu-item",
                        "active-class": "admin-menu-active"
                      }, null, 8, ["to", "prepend-icon", "title"]))
                    : (_openBlock(), _createBlock(_component_v_list_group, {
                        key: 1,
                        value: item.title
                      }, {
                        activator: _withCtx(({ props }) => [
                          _createVNode(_component_v_list_item, _mergeProps({ ref_for: true }, props, {
                            "prepend-icon": item.icon,
                            title: item.title,
                            class: "admin-menu-item"
                          }), null, 16, ["prepend-icon", "title"])
                        ]),
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.children, (child) => {
                            return (_openBlock(), _createBlock(_component_v_list_item, {
                              key: child.title,
                              to: (child as any).to || undefined,
                              "prepend-icon": child.icon,
                              title: child.title,
                              class: "admin-menu-item admin-submenu-item",
                              "active-class": "admin-menu-active",
                              onClick: ($event: any) => ((child as any).action ? handleMenuAction((child as any).action) : null)
                            }, null, 8, ["to", "prepend-icon", "title", "onClick"]))
                          }), 128))
                        ]),
                        _: 2
                      }, 1032, ["value"]))
                ], 64))
              }), 128))
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_v_main, { class: "admin-main" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_container, {
            fluid: "",
            class: "pa-4"
          }, {
            default: _withCtx(() => [
              _renderSlot(_ctx.$slots, "default")
            ]),
            _: 3
          })
        ]),
        _: 3
      }),
      _createVNode(HolidayRemote, {
        ref_key: "holidayRemoteRef",
        ref: holidayRemoteRef
      }, null, 512),
      _createVNode(SugaRemote, {
        ref_key: "sugaRemoteRef",
        ref: sugaRemoteRef
      }, null, 512),
      _createVNode(TaxRateRemote, {
        ref_key: "taxRateRemoteRef",
        ref: taxRateRemoteRef
      }, null, 512)
    ]),
    _: 3
  }))
}
}

})